import styled from 'styled-components'

export const MainContainer = styled.div`
  max-width: 800px;
  margin-bottom: 1.5rem;

  hr {
    margin: ${({ theme }) => `${theme.spacings[6]} 0`};
  }
`
